import React from "react";
import { GlobalStyles as MuiGlobalStyles, useTheme } from "@mui/material";

const GlobalStyles: React.FC = () => {
  const theme = useTheme();

  return (
    <MuiGlobalStyles
      styles={{
        "html, body": {
          backgroundColor: theme.palette.background.paper,
          minHeight: "100vh",
          margin: 0,
          padding: 0,
          fontFamily: "Noto Sans",
        },
      }}
    />
  );
};

export default GlobalStyles;
